export const Marquee = ({ t }) => {
  const items = [...t.marquee, ...t.marquee, ...t.marquee];
  return (
    <div data-testid="marquee-section" className="border-y border-[#C5A059]/15 bg-[#0B132B] py-5 overflow-hidden">
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10 font-mono2 text-xs uppercase tracking-[0.3em] text-slate-500">
            {item}
            <span className="text-[#C5A059]/60">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};
